// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/BankAuto.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bank_main {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: stretch;
    height: 100%;
}

.bank_btns {
    display: flex;
    flex-direction: column;
    width: min-content;
    height: min-content;
}
.bank_btns > button {
    font-size: 1.5em;
    text-align: left;
}
.bank_btns > .btn1 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: 50% 1rem;
    padding: 11rem 0.8rem 0.8rem 0.8rem;

}
.bank_btns > .btn1:hover {
    background-color: black;
    color: white;
    border-color: black;
    filter: invert(1);
}
.bank_btns > .btn2 {
    padding: 3rem 0.8rem 0.8rem 0.8rem;
}

@media(max-width: 1300px) {
    .bank_salad {
        min-width: 100vw !important;
        max-width: none !important;
    }

    .bank_lists {
        max-height: 22rem;
    }
}

.future_graph { 
    width: 100%;
    height: 25rem;
    min-width: 7cm;
}

.bank_salad {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    flex-wrap: wrap;
    max-width: min(calc(100vw - 40rem), calc(1820px - 40rem));
}

.bank_lists {
    min-width: 40rem;
    flex-grow: 1;
    display: flex;
}

.spread_stat_box {
    display: flex;
    flex-direction: column;
    max-height: 22rem;
    width: 100%;
}
.spread_stat {
    border: 3px solid rgb(0, 247, 255);
    background-color: rgba(0, 238, 255, 0.315);
    margin: 4px;
    padding: 5px;
    border-radius: 4px;
    min-width: 5rem;
    display: flex;
}
.spread_stat > h1 {
    font-size: 1.4rem;
    margin: 0;
    margin-left: 10px;
    text-align: right;
}
.spread_stat > h2 {
    font-size: 1rem;
    margin: auto;
    margin-left: 5px;
    width: 100%;
    text-align: left;
    border-bottom: 1px dotted white;
    border-radius: 0 0 1rem 0;
}
.spread_total {
    border: 3px solid rgb(255, 255, 255) !important;
    background-color: rgba(0, 0, 0, 0) !important;
}

.constants_box {
    max-width: max-content;
}

.constants_stat_box {
    display: grid;
    grid-template-columns: 1fr;
}
h1.constants_field {
    font-size: 1.5rem;
    margin: 0;
    text-align: right;
}
h2.constants_field {
    font-size: 1rem;
    margin: 0;
}
.constants_tweeker {
    display: flex;
    align-content: flex-end;
    padding: 0.3rem;
}
.constants_tweeker > h1 {
    text-align: left;
    padding-left: 1rem;
}
.constants_tweeker > button {
    border: none;
}

.plot_center {
    display: flex;
    align-content: center;
    justify-content: center;
}

.bank_lists_buttons {
    display: grid;
    margin-top: 0.5rem;
    grid-template-rows: 5rem 5rem 5rem 5rem;
    grid-template-columns: 5rem;
}
.bank_add_button {
    width: 2.5rem;
    height: 2.5rem;
}
.bank_lists_buttons > button {
    margin: 3px;
}
.bank_lists_buttons > button:disabled {
    background-color: white;
    color: black;
}

.selected {
    background-color: rgb(181, 250, 255) !important;
    color: black;
}

.saver {
    border: 3px solid rgb(0, 247, 255);
    background-color: rgba(0, 238, 255, 0.315);
    border-radius: 5px;
    margin: 8px;
    padding: 5px;
    display: flex;
    flex-direction: row;
}
.saver * h1 {
    font-size: 1.5rem;
    margin: 0;
    margin-top: 0.5rem;
    width: min-content;
    max-width: 7cm;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.stop_wrap {
    overflow: visible !important;
}
.saver * h2 {
    font-size: 1rem;
    margin-top: 1rem;
    color: gray;
    float: right;
}
.saver * h3 {
    margin: 0;
    font-size: 1rem;
    margin-bottom: 1rem;
}
.saver > .circle {
    background-color: "#00000000";
    height: 100%;
    margin-top: 3px;
    margin-right: 0.5rem;
}
.saver > .buttons {
    flex-grow: 0;
}
.saver > .buttons > button {
    width: 2rem;
    height: 2rem;
    border: none;
    font-size: 1.4rem;
    padding: 0;
}

@keyframes pulseRed {
    0% {
        background-color: rgba(255, 0, 0, 0.5);
        border-color: rgba(255, 0, 0, 0.8);
    }
    50% {
        background-color: rgba(255, 0, 0, 0.8);
        border-color: rgba(255, 0, 0, 1);
    }
    100% {
        background-color: rgba(255, 0, 0, 0.5);
        border-color: rgba(255, 0, 0, 0.8);
    }
}

.saver_deleting {
    animation: pulseRed 0.5s infinite;
}

.process_btn {
    padding: 1rem;
    font-size: large;
    width: 100%;
    margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/systems/banking_sys/Banking.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,yDAAqD;IACrD,4BAA4B;IAC5B,6BAA6B;IAC7B,mCAAmC;;AAEvC;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,kCAAkC;AACtC;;AAEA;IACI;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,yDAAyD;AAC7D;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,kCAAkC;IAClC,0CAA0C;IAC1C,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,SAAS;IACT,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAC/B,yBAAyB;AAC7B;AACA;IACI,+CAA+C;IAC/C,6CAA6C;AACjD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,0BAA0B;AAC9B;AACA;IACI,iBAAiB;IACjB,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,SAAS;AACb;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,+CAA+C;IAC/C,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,0CAA0C;IAC1C,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;AACA;IACI,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI;QACI,sCAAsC;QACtC,kCAAkC;IACtC;IACA;QACI,sCAAsC;QACtC,gCAAgC;IACpC;IACA;QACI,sCAAsC;QACtC,kCAAkC;IACtC;AACJ;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,SAAS;AACb","sourcesContent":[".bank_main {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    align-content: stretch;\r\n    height: 100%;\r\n}\r\n\r\n.bank_btns {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: min-content;\r\n    height: min-content;\r\n}\r\n.bank_btns > button {\r\n    font-size: 1.5em;\r\n    text-align: left;\r\n}\r\n.bank_btns > .btn1 {\r\n    background-image: url('../../../public/BankAuto.png');\r\n    background-repeat: no-repeat;\r\n    background-position: 50% 1rem;\r\n    padding: 11rem 0.8rem 0.8rem 0.8rem;\r\n\r\n}\r\n.bank_btns > .btn1:hover {\r\n    background-color: black;\r\n    color: white;\r\n    border-color: black;\r\n    filter: invert(1);\r\n}\r\n.bank_btns > .btn2 {\r\n    padding: 3rem 0.8rem 0.8rem 0.8rem;\r\n}\r\n\r\n@media(max-width: 1300px) {\r\n    .bank_salad {\r\n        min-width: 100vw !important;\r\n        max-width: none !important;\r\n    }\r\n\r\n    .bank_lists {\r\n        max-height: 22rem;\r\n    }\r\n}\r\n\r\n.future_graph { \r\n    width: 100%;\r\n    height: 25rem;\r\n    min-width: 7cm;\r\n}\r\n\r\n.bank_salad {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-grow: 1;\r\n    flex-wrap: wrap;\r\n    max-width: min(calc(100vw - 40rem), calc(1820px - 40rem));\r\n}\r\n\r\n.bank_lists {\r\n    min-width: 40rem;\r\n    flex-grow: 1;\r\n    display: flex;\r\n}\r\n\r\n.spread_stat_box {\r\n    display: flex;\r\n    flex-direction: column;\r\n    max-height: 22rem;\r\n    width: 100%;\r\n}\r\n.spread_stat {\r\n    border: 3px solid rgb(0, 247, 255);\r\n    background-color: rgba(0, 238, 255, 0.315);\r\n    margin: 4px;\r\n    padding: 5px;\r\n    border-radius: 4px;\r\n    min-width: 5rem;\r\n    display: flex;\r\n}\r\n.spread_stat > h1 {\r\n    font-size: 1.4rem;\r\n    margin: 0;\r\n    margin-left: 10px;\r\n    text-align: right;\r\n}\r\n.spread_stat > h2 {\r\n    font-size: 1rem;\r\n    margin: auto;\r\n    margin-left: 5px;\r\n    width: 100%;\r\n    text-align: left;\r\n    border-bottom: 1px dotted white;\r\n    border-radius: 0 0 1rem 0;\r\n}\r\n.spread_total {\r\n    border: 3px solid rgb(255, 255, 255) !important;\r\n    background-color: rgba(0, 0, 0, 0) !important;\r\n}\r\n\r\n.constants_box {\r\n    max-width: max-content;\r\n}\r\n\r\n.constants_stat_box {\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n}\r\nh1.constants_field {\r\n    font-size: 1.5rem;\r\n    margin: 0;\r\n    text-align: right;\r\n}\r\nh2.constants_field {\r\n    font-size: 1rem;\r\n    margin: 0;\r\n}\r\n.constants_tweeker {\r\n    display: flex;\r\n    align-content: flex-end;\r\n    padding: 0.3rem;\r\n}\r\n.constants_tweeker > h1 {\r\n    text-align: left;\r\n    padding-left: 1rem;\r\n}\r\n.constants_tweeker > button {\r\n    border: none;\r\n}\r\n\r\n.plot_center {\r\n    display: flex;\r\n    align-content: center;\r\n    justify-content: center;\r\n}\r\n\r\n.bank_lists_buttons {\r\n    display: grid;\r\n    margin-top: 0.5rem;\r\n    grid-template-rows: 5rem 5rem 5rem 5rem;\r\n    grid-template-columns: 5rem;\r\n}\r\n.bank_add_button {\r\n    width: 2.5rem;\r\n    height: 2.5rem;\r\n}\r\n.bank_lists_buttons > button {\r\n    margin: 3px;\r\n}\r\n.bank_lists_buttons > button:disabled {\r\n    background-color: white;\r\n    color: black;\r\n}\r\n\r\n.selected {\r\n    background-color: rgb(181, 250, 255) !important;\r\n    color: black;\r\n}\r\n\r\n.saver {\r\n    border: 3px solid rgb(0, 247, 255);\r\n    background-color: rgba(0, 238, 255, 0.315);\r\n    border-radius: 5px;\r\n    margin: 8px;\r\n    padding: 5px;\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n.saver * h1 {\r\n    font-size: 1.5rem;\r\n    margin: 0;\r\n    margin-top: 0.5rem;\r\n    width: min-content;\r\n    max-width: 7cm;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n.stop_wrap {\r\n    overflow: visible !important;\r\n}\r\n.saver * h2 {\r\n    font-size: 1rem;\r\n    margin-top: 1rem;\r\n    color: gray;\r\n    float: right;\r\n}\r\n.saver * h3 {\r\n    margin: 0;\r\n    font-size: 1rem;\r\n    margin-bottom: 1rem;\r\n}\r\n.saver > .circle {\r\n    background-color: \"#00000000\";\r\n    height: 100%;\r\n    margin-top: 3px;\r\n    margin-right: 0.5rem;\r\n}\r\n.saver > .buttons {\r\n    flex-grow: 0;\r\n}\r\n.saver > .buttons > button {\r\n    width: 2rem;\r\n    height: 2rem;\r\n    border: none;\r\n    font-size: 1.4rem;\r\n    padding: 0;\r\n}\r\n\r\n@keyframes pulseRed {\r\n    0% {\r\n        background-color: rgba(255, 0, 0, 0.5);\r\n        border-color: rgba(255, 0, 0, 0.8);\r\n    }\r\n    50% {\r\n        background-color: rgba(255, 0, 0, 0.8);\r\n        border-color: rgba(255, 0, 0, 1);\r\n    }\r\n    100% {\r\n        background-color: rgba(255, 0, 0, 0.5);\r\n        border-color: rgba(255, 0, 0, 0.8);\r\n    }\r\n}\r\n\r\n.saver_deleting {\r\n    animation: pulseRed 0.5s infinite;\r\n}\r\n\r\n.process_btn {\r\n    padding: 1rem;\r\n    font-size: large;\r\n    width: 100%;\r\n    margin: 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
